import { useState } from "react";
import { useNavigate } from "react-router";
import { EyeCloseIcon, EyeIcon, MetaIcon } from "../../icons";
import Label from "../form/Label";
import Input from "../form/input/InputField";
import { useAuth } from "../../context/AuthContext";
import { Link } from "react-router-dom";
import axios from "../../lib/axios";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
// import { enablePushNotifications } from "../../services/firebasePushNotification";

export default function SignInForm() {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login, loginWithGoogle, sendLoginOtp, verifyLoginOtp, resendLoginOtp, user, token, stores } = useAuth();
  const [socialLoading, setSocialLoading] = useState<string | null>(null);
  const [error, setError] = useState("");
  const [searchParams] = useSearchParams();
  // const { login, loginWithGoogle, loginWithFacebook } = useAuth();
  const navigate = useNavigate();

  // Login method state
  const [loginMethod, setLoginMethod] = useState<'password' | 'otp'>('password');

  // Unified login input states
  const [loginInput, setLoginInput] = useState("");

  // OTP states
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpExpiry, setOtpExpiry] = useState<number | null>(null);
  const [countdown, setCountdown] = useState<number>(0);

  // Trial expiry modal is shown from AppHeader after login navigation

  // Auto-detect input type and update appropriate state
  const handleLoginInputChange = (value: string) => {
    setLoginInput(value);
    setEmail(value); // Keep email state for compatibility
  };

  // Removed auto-accept invitation functionality - invitations will be handled by AccessGuard modal

  
  // Get invitation token from URL params
  const inviteToken = searchParams.get("invite");

  // Auto-fill email from invitation data
  useEffect(() => {
    const autoFillEmailFromInvitation = async () => {
      // First check if we have invitation data in localStorage from InvitationLanding
      const storedInvitationData = localStorage.getItem('invitation_data');
      if (storedInvitationData) {
        try {
          const invitationData = JSON.parse(storedInvitationData);
          if (invitationData.email && !email) {
            setEmail(invitationData.email);
            console.log('Auto-filled email from stored invitation data:', invitationData.email);
          }
        } catch (error) {
          console.error('Failed to parse stored invitation data:', error);
        }
      }

      // If no stored data but we have a token, validate it to get email
      if (inviteToken && !email) {
        try {
          const response = await axios.post('/invitations/validate', { token: inviteToken });
          if (response.data.success && response.data.invitation?.email) {
            setEmail(response.data.invitation.email);
            console.log('Auto-filled email from token validation:', response.data.invitation.email);

            // Store the invitation data for later use
            localStorage.setItem('invitation_data', JSON.stringify({
              email: response.data.invitation.email,
              merchant: response.data.invitation.merchant,
              role: response.data.invitation.role,
              invited_by: response.data.invitation.invited_by
            }));
          }
        } catch (error) {
          console.error('Failed to validate invitation token for email auto-fill:', error);
        }
      }
    };

    autoFillEmailFromInvitation();
  }, [inviteToken, email]);

  // Store invitation token in session for login processing
  //  useEffect(() => {
  //   if (inviteToken) {
  //     // Store the invitation token in session storage for the registration process
  //     sessionStorage.setItem('pending_invitation_token', inviteToken);
  //     console.log('Stored invitation token from URL params:', inviteToken);
  //     // Also store in session for backend processing
  //     fetch('/api/invitations/store-session', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({ token: inviteToken }),
  //     }).catch(error => {
  //       console.error('Failed to store invitation session:', error);
  //     });
  //   }
  // }, [inviteToken]);

  async function handleGoogleLogin() {
    setError("");
    setSocialLoading("google");

    try {
      const result = await loginWithGoogle();
      if (result.success) {
        // loginWithGoogle already re-hydrates auth state via /me (which returns
        // user_role + skip), so routing behaves exactly like the OTP/password
        // flow. Still honor the deactivated-account guard before navigating.
        try {
          const response = await axios.get("/me");
          if (
            response.status === 200 &&
            response.data.user?.is_deactivated &&
            typeof window !== "undefined" &&
            window.location.pathname !== "/account-reactivate"
          ) {
            window.location.href = "/account-reactivate";
            return;
          }
        } catch {
          // /me failed - fall through to normal navigation
        }
        navigate("/");
      } else {
        // Handle existing account error specifically
        if (result.error?.includes("Account already exists")) {
          setError(result.error);
        } else {
          setError(result.error || "Google login failed. Please try again.");
        }
      }
    } catch (err) {
      setError("Google login failed. Please try again.");
    } finally {
      setSocialLoading(null);
    }
  }

  async function handleFacebookLogin() {
    setError("");
    setSocialLoading("facebook");

    try {
      const result = await loginWithFacebook();
      if (result.success) {
        navigate("/");
      } else {
        // Handle existing account error specifically
        if (result.error?.includes("Account already exists")) {
          setError(result.error);
        } else {
          setError(result.error || "Facebook login failed. Please try again.");
        }
      }
    } catch (err) {
      setError("Facebook login failed. Please try again.");
    } finally {
      setSocialLoading(null);
    }
  }

  async function handleLogin(e: React.FormEvent) {
    e.preventDefault();
    setError("");

    // Client-side validation
    if (!email || !password) {
      setError("Please enter both email and password.");
      return;
    }

    setLoading(true);

    try {
      const success = await login(email, password);
      if (success) {
        const shop = localStorage.getItem("shop") || "";

        const response = await axios.get('/me');

            if (response.status === 200 && response.data.user) {
                if (response.data.user.is_deactivated) {
                    if (typeof window !== 'undefined') {
                        if (window.location.pathname !== '/account-reactivate') {
                            window.location.href = '/account-reactivate';
                        }
                    }
                    return;
                }

                if (!shop) {
                  const shopNow = localStorage.getItem("shop") || "";
                }

            } else {
                navigate("/");
                return;
            }

        navigate("/");
      } else {
        setError("Invalid email or password. Please try again.");
      }
    } catch (err) {
      setError("Login failed. Please check your credentials and try again.");
    } finally {
      setLoading(false);
    }
  };

  // OTP handlers
  const handleSendOtp = async () => {
    setError("");
    if (!loginInput) {
      setError("Please enter your email or phone number.");
      return;
    }

    // Check if input is email or phone number
    const cleanValue = loginInput.replace(/\s/g, '');
    const isPhoneNumber = /^[\+]?[\d\s\-\(\)]+$/.test(cleanValue) && /\d/.test(cleanValue);

    if (isPhoneNumber) {
      const digitsOnly = loginInput.replace(/\D/g, '');
      if (digitsOnly.length < 10) {
        setError("Please enter a valid phone number (at least 10 digits).");
        return;
      }
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(loginInput)) {
        setError("Please enter a valid email address.");
        return;
      }
    }

    setOtpLoading(true);
    const type = isPhoneNumber ? 'phone' : 'email';

    try {
      const result = await sendLoginOtp(loginInput, type);
      if (result.success) {
        setOtpSent(true);
        setOtpExpiry(result.expiresIn || 300);
        setCountdown(result.expiresIn || 300);
        setError("");
      } else {
        setError(result.error || "Failed to send OTP. Please try again.");
      }
    } catch (err) {
      setError("Failed to send OTP. Please try again.");
    } finally {
      setOtpLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    setError("");
    if (!otp || otp.length !== 6) {
      setError("Please enter a valid 6-digit OTP.");
      return;
    }

    setOtpLoading(true);
    const cleanValue = loginInput.replace(/\s/g, '');
    const isPhoneNumber = /^[\+]?[\d\s\-\(\)]+$/.test(cleanValue) && /\d/.test(cleanValue);
    const type = isPhoneNumber ? 'phone' : 'email';

    try {
      const result = await verifyLoginOtp(loginInput, otp, type);
       if (result.success) {
        const shop = localStorage.getItem("shop") || "";

        const response = await axios.get('/me');

            if (response.status === 200 && response.data.user) {
                if (response.data.user.is_deactivated) {
                    if (typeof window !== 'undefined') {
                        if (window.location.pathname !== '/account-reactivate') {
                            window.location.href = '/account-reactivate';
                        }
                    }
                    return;
                }

                if (!shop) {
                  const shopNow = localStorage.getItem("shop") || "";
                }

            } else {
                navigate("/");
                return;
            }

        navigate("/");
      } else {
        setError("Invalid OTP. Please try again.");
      }
    } catch (err) {
      setError("Failed to verify OTP. Please try again.");
    } finally {
      setOtpLoading(false);
    }
  };

  const handleResendOtp = async () => {
    setError("");
    const cleanValue = loginInput.replace(/\s/g, '');
    const isPhoneNumber = /^[\+]?[\d\s\-\(\)]+$/.test(cleanValue) && /\d/.test(cleanValue);
    const type = isPhoneNumber ? 'phone' : 'email';

    setOtpLoading(true);
    try {
      const result = await resendLoginOtp(loginInput, type);
      if (result.success) {
        setOtpExpiry(result.expiresIn || 300);
        setCountdown(result.expiresIn || 300);
        setOtp('');
        setError("");
      } else {
        setError(result.error || "Failed to resend OTP. Please try again.");
      }
    } catch (err) {
      setError("Failed to resend OTP. Please try again.");
    } finally {
      setOtpLoading(false);
    }
  };

  // Countdown timer for OTP expiry
  useEffect(() => {
    if (countdown > 0 && otpSent) {
      const timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [countdown, otpSent]);

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };


  return (
    <div className="relative w-full dark:bg-[#080f1c]">
      <img
        src="/images/shape/grid-01.svg"
        alt=""
        aria-hidden="true"
        className="pointer-events-none fixed right-0 top-0 w-[450px] xl:w-[750px] opacity-80 dark:opacity-90 dark:[filter:brightness(0)_invert(1)]"
        style={{ zIndex: 0 }}
      />
      <img
        src="/images/shape/grid-01.svg"
        alt=""
        aria-hidden="true"
        className="pointer-events-none fixed left-0 bottom-0 w-[450px] xl:w-[750px] rotate-180 opacity-80 dark:opacity-90 dark:[filter:brightness(0)_invert(1)]"
        style={{ zIndex: 0 }}
      />
      <div className="flex justify-center sm:mt-10 sm:mb-10 mt-2 mb-2">
        <Link to="/" className="dark:hidden">
          <img
            className="w-[120px] h-auto sm:w-[200px] sm:h-[42px]"
            src="/images/logo/netsight-Black.svg"
            alt="Logo"
          />
        </Link>
        <Link to="/" className="hidden dark:block">
          <img
            className="w-[120px] h-auto sm:w-[200px] sm:h-[42px]"
            src="/images/logo/netsight-white.svg"
            alt="Logo"
          />
        </Link>
      </div>
      <div
        className="relative flex flex-col justify-center flex-1 w-full max-w-md mx-auto dark:bg-[#0d1828] p-6 rounded-md border border-gray-100 dark:border-[#FFFFFF0F] shadow-theme-lg"
        style={{ zIndex: 3 }}
      >
        <div>
          <div className="sm:block">
            <h1 className=" font-semibold text-gray-800 dark:text-white/90 text-xl text-center">
              Welcome Back
            </h1>
            {/* <p className="text-sm text-gray-500 dark:text-white text-center mb-3">
              Sign in to see your morning intelligence.
            </p> */}
          </div>
          <div>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-1 sm:gap-5 sm:mt-3 mt-1">
              <button
                onClick={handleGoogleLogin}
                disabled={socialLoading === "google"}
                className="inline-flex items-center justify-center gap-2 sm:py-2 py-1 text-sm font-normal text-gray-700 transition-colors bg-gray-100 dark:bg-[#111f33] rounded-[6px] px-1 hover:bg-gray-200 hover:text-gray-800 dark:bg-white/5 dark:text-white/90 dark:hover:bg-white/10 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.7511 10.1944C18.7511 9.47495 18.6915 8.94995 18.5626 8.40552H10.1797V11.6527H15.1003C15.0011 12.4597 14.4654 13.675 13.2749 14.4916L13.2582 14.6003L15.9087 16.6126L16.0924 16.6305C17.7788 15.1041 18.7511 12.8583 18.7511 10.1944Z"
                    fill="#4285F4"
                  />
                  <path
                    d="M10.1788 18.75C12.5895 18.75 14.6133 17.9722 16.0915 16.6305L13.274 14.4916C12.5201 15.0068 11.5081 15.3666 10.1788 15.3666C7.81773 15.3666 5.81379 13.8402 5.09944 11.7305L4.99473 11.7392L2.23868 13.8295L2.20264 13.9277C3.67087 16.786 6.68674 18.75 10.1788 18.75Z"
                    fill="#34A853"
                  />
                  <path
                    d="M5.10014 11.7305C4.91165 11.186 4.80257 10.6027 4.80257 9.99992C4.80257 9.3971 4.91165 8.81379 5.09022 8.26935L5.08523 8.1534L2.29464 6.02954L2.20333 6.0721C1.5982 7.25823 1.25098 8.5902 1.25098 9.99992C1.25098 11.4096 1.5982 12.7415 2.20333 13.9277L5.10014 11.7305Z"
                    fill="#FBBC05"
                  />
                  <path
                    d="M10.1789 4.63331C11.8554 4.63331 12.9864 5.34303 13.6312 5.93612L16.1511 3.525C14.6035 2.11528 12.5895 1.25 10.1789 1.25C6.68676 1.25 3.67088 3.21387 2.20264 6.07218L5.08953 8.26943C5.81381 6.15972 7.81776 4.63331 10.1789 4.63331Z"
                    fill="#EB4335"
                  />
                </svg>
                {socialLoading === "google"
                  ? "Signing in..."
                  : "Sign in with Google"}
              </button>
              {/* <button
                onClick={handleFacebookLogin}
                disabled={socialLoading === "facebook"}
                className="inline-flex items-center justify-center gap-3 py-3 text-sm font-normal text-gray-700 transition-colors bg-gray-100 rounded-lg px-3 hover:bg-gray-200 hover:text-gray-800 dark:bg-white/5 dark:text-white/90 dark:hover:bg-white/10 disabled:opacity-50 disabled:cursor-not-allowed">
                <div className=" connection-icon-bg">
                    <MetaIcon className="w-6 h-6" />
                </div>
                {socialLoading === "facebook" ? "Signing in..." : "Sign up with Facebook"}
              </button> */}
            </div>
            {/* <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-200 dark:border-gray-800"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="p-2 text-gray-400 bg-white dark:bg-gray-900 sm:px-5 sm:py-2">
                  Or
                </span>
              </div>
            </div> */}
            <div className="relative  sm:py-2 flex items-center">
              {/* Left line */}
              <div className="flex-grow border-t border-gray-200 dark:border-gray-800"></div>

              {/* Text */}
              <span className="mx-1 text-sm text-gray-400">Or</span>

              {/* Right line */}
              <div className="flex-grow border-t border-gray-200 dark:border-gray-800"></div>
            </div>

            {loginMethod === 'password' ? (
              <form onSubmit={handleLogin}>
              <div className="space-y-5 sm:-mt-2 mt-0">
                {error && (
                  <div className="p-3 text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg dark:bg-red-900/20 dark:text-red-400 dark:border-red-800">
                    {error}
                  </div>
                )}
                <div className="">
                  <Label className="dark:text-white">
                    Email <span className="text-error-500">*</span>{" "}
                  </Label>
                  <Input
                    placeholder="info@gmail.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="mb-2">
                  <Label className="dark:text-white ">
                    Password <span className="text-error-500">*</span>{" "}
                  </Label>
                  <div className="relative">
                    <Input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
                    >
                      {showPassword ? (
                        <EyeIcon className="fill-gray-500 dark:fill-gray-400 size-5" />
                      ) : (
                        <EyeCloseIcon className="fill-gray-500 dark:fill-gray-400 size-5" />
                      )}
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-between mt-2 mb-2">
                  <button
                    type="button"
                    onClick={() => {
                      setLoginMethod('otp');
                      setOtpSent(false);
                      setError('');
                    }}
                    className="text-sm text-brand-500 hover:text-brand-600 dark:text-brand-400 mt-[-1rem]"
                  >
                    Sign in with OTP
                  </button>
                  <Link
                    to="/forgot-password"
                    className="text-sm text-brand-500 hover:text-brand-600 dark:text-brand-400 mt-[-1rem]"
                  >
                    Forgot password?
                  </Link>
                </div>

                <div>
                  <button
                    type="submit"
                    disabled={loading}
                    className="flex items-center justify-center w-full px-6 py-2 text-sm font-medium text-white transition rounded-[6px] bg-teal-600 hover:bg-teal-700 disabled:opacity-60 -mt-2"
                  >
                    {loading ? "Signing in..." : "Sign in"}
                  </button>
                </div>
              </div>
            </form>
            ) : (
              <form onSubmit={(e) => { e.preventDefault(); handleVerifyOtp(); }}>
                <div className="space-y-5 sm:-mt-2 mt-0">
                  {error && (
                    <div className="p-3 text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg dark:bg-red-900/20 dark:text-red-400 dark:border-red-800">
                      {error}
                    </div>
                  )}

                  {!otpSent ? (
                    <>
                      {/* Unified Login Input */}
                      <div className="">
                        <Label className="dark:text-white">
                          Email or Phone Number <span className="text-error-500">*</span>{" "}
                        </Label>
                        <Input
                          placeholder="Enter your email or phone number"
                          value={loginInput}
                          onChange={(e) => handleLoginInputChange(e.target.value)}
                          disabled={otpLoading}
                        />
                      </div>

                      <div className="flex items-center justify-between">
                        <button
                          type="button"
                          onClick={() => {
                            setLoginMethod('password');
                            setOtpSent(false);
                            setError('');
                          }}
                          className="text-sm text-brand-500 hover:text-brand-600 dark:text-brand-400"
                        >
                          Sign in with password
                        </button>
                      </div>

                      <div>
                        <button
                          type="button"
                          onClick={handleSendOtp}
                          disabled={otpLoading}
                          className="flex items-center justify-center w-full px-6 py-2 text-sm font-medium text-white transition rounded-[6px] bg-teal-600 hover:bg-teal-700 disabled:opacity-60 -mt-2"
                        >
                          {otpLoading ? "Sending OTP..." : "Send OTP"}
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="text-center mb-4">
                        <p className="text-sm text-gray-600 dark:text-gray-400">
                          OTP sent to <span className="font-medium">{loginInput}</span>
                        </p>
                        {countdown > 0 && (
                          <p className="text-xs text-gray-500 dark:text-gray-500 mt-1">
                            Expires in {formatTime(countdown)}
                          </p>
                        )}
                      </div>

                      {/* OTP Input */}
                      <div className="">
                        <Label className="dark:text-white">
                          Enter OTP <span className="text-error-500">*</span>{" "}
                        </Label>
                        <Input
                          type="text"
                          placeholder="Enter 6-digit OTP"
                          value={otp}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '').slice(0, 6);
                            setOtp(value);
                          }}
                          disabled={otpLoading}
                          maxLength={6}
                          className="text-center text-lg tracking-widest"
                        />
                      </div>

                      <div>
                        <button
                          type="submit"
                          disabled={otpLoading || otp.length !== 6}
                          className="flex items-center justify-center w-full px-4 py-2 text-sm font-medium text-white transition rounded-[6px] bg-teal-600 hover:bg-teal-700 disabled:opacity-60 -mt-2"
                        >
                          {otpLoading ? "Verifying..." : "Verify OTP"}
                        </button>
                      </div>

                      <div className="text-center space-y-1.5 -mt-3">
                        {countdown > 0 ? (
                          <p className="text-sm text-gray-500 dark:text-gray-400">
                            Didn't receive? Resend in {formatTime(countdown)}
                          </p>
                        ) : (
                          <button
                            type="button"
                            onClick={handleResendOtp}
                            disabled={otpLoading}
                            className="text-sm text-brand-500 hover:text-brand-600 dark:text-brand-400 font-medium block mx-auto"
                          >
                            Resend OTP
                          </button>
                        )}

                        <button
                          type="button"
                          onClick={() => {
                            setLoginMethod('password');
                            setOtpSent(false);
                            setOtp('');
                            setError('');
                          }}
                          className="text-sm text-brand-500 hover:text-brand-600 dark:text-brand-400 font-medium block mx-auto"
                        >
                          Sign in with password
                        </button>

                        <button
                          type="button"
                          onClick={() => {
                            setOtpSent(false);
                            setOtp('');
                            setError('');
                          }}
                          className="text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300 block mx-auto"
                        >
                          Change email/phone
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </form>
            )}

            {/* <div className="mt-5">
              <p className="text-sm font-normal text-center text-gray-700 dark:text-gray-400 sm:text-start">
                Don&apos;t have an account? {""}
                <Link
                  to="/signup"
                  className="text-brand-500 hover:text-brand-600 dark:text-brand-400"
                >
                  Sign Up
                </Link>
              </p>
            </div> */}
          </div>
        </div>

        {/* <div className="block lg:hidden mb-4 flex flex-col items-center mt-5">
          <img
            className="my-3 md:max-w-sm mx-auto"
            src="/images/logo/signup-page-mobile.png"
            alt="Netsight"
          />
          <ul className="text-gray-600 dark:text-white width-full dot-primary-si text-center">
            <li>
              <span></span> Integrate within 2 mins
            </li>
            <li>
              <span></span> Get daily reports on WhatsApp
            </li>
            <li>
              <span></span> Get key D2C metrics at one place
            </li>
          </ul>
        </div> */}
      </div>
      <div className="sm:mt-10 mt-5 sm:mb-10 mb-5 flex flex-col gap-2">
        <div className=" flex justify-center -mb-2">
          <p className="text-sm font-normal text-gray-700 dark:text-white sm:text-start text-center">
            New to Netsights?{" "}
            <Link
              to="/signup"
              className="text-brand-500 hover:text-brand-600 dark:text-brand-400"
            >
              {" "}
              Sign up
            </Link>
          </p>
        </div>
        {/* <div className="flex items-center justify-center"> */}
        {/* <div className="flex items-center gap-3">
                    <Checkbox checked={isChecked} onChange={setIsChecked} />
                    <span className="block font-normal text-gray-700 text-theme-sm dark:text-gray-400">
                      Keep me logged in
                    </span>
                  </div> */}
        {/* <Link
            to="/forgot-password"
            className="text-sm text-brand-500 hover:text-brand-600 dark:text-brand-400 text-center"
          >
            Forgot password?
          </Link>
        </div> */}
      </div>

    </div>
  );
}
